import React, { useState, useEffect } from "react";
import { Flex, Grid, useColorModeValue } from "@chakra-ui/react";
import PieChart from "components/Charts/PieChart";
import { useSelector } from "react-redux";
import DataByDateBarChart from "components/Charts/DataByDateBarChart";
import Statistics from "../Components/Statistics";
import DataByDistrictHeatmap from "components/Charts/DataByDistrictHeatmap";

export default function Reports() {
  const loading = useSelector((state) => state.analytics.loading);

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Statistics />
      <Grid
        templateColumns={{ sm: "1fr", md: "1fr 1fr", lg: "1fr 1fr" }} 
        templateRows={{ sm: "1fr auto", md: "1fr", lg: "1fr" }}
        gap="24px"
      >
        <PieChart
          title="Status Distribution"
          exportFileName="Status_Distribution"
          loading={loading}
          showExportButton={true}
        />

        <DataByDateBarChart
          title="Data Overview"
          showExportButton={true}
          fileName="DataByDateChart"
          selectedTable="packages"
        />
      </Grid>
      <Grid
        templateColumns={{ sm: "1fr", md: "1fr", lg: "1fr" }}
        gap="24px"
        mt={6} 
      >
        <DataByDistrictHeatmap />
      </Grid>
    </Flex>
  );
}
